document.addEventListener("DOMContentLoaded", function () {
  const originalButtons = document.querySelectorAll(".slider-nav__btn");
  const cloneButtons = document.querySelectorAll(".slider-nav-btn");

  cloneButtons.forEach(cloneBtn => {
    const direction = cloneBtn.getAttribute("name");

    // Find the matching original button
    const originalBtn = Array.from(originalButtons).find(btn => btn.getAttribute("name") === direction);

    if (originalBtn) {
      // Click delegation
      cloneBtn.addEventListener("click", () => {
        if (!originalBtn.disabled) {
          originalBtn.click();
        }
      });

      // Keep clone disabled in sync with the original
      const observer = new MutationObserver(() => {
        cloneBtn.disabled = originalBtn.disabled;
      });

      observer.observe(originalBtn, { attributes: true, attributeFilter: ["disabled"] });
    }
  });
});
